import { useEffect, useState } from 'react';
import { ViewModalHeader } from './ViewModalHeader';
import axios from 'axios';
import Swal from 'sweetalert2';
import './styles.css'; // Incluye estilos personalizados
import { useAuth } from '../../../../../app/modules/auth';
import { getmyuser, getroles } from '../../../../../app/modules/custom/accounts/userss/request/request';

const API_URL = process.env.REACT_APP_API_URL;

type Role = {
  id: number;
  name: string;
  description?: string;
};

type User = {
  firstName: string;
  lastName: string;
  email: string;
  NumberPhone: string;
  position: string;
  Roles: Role[];
  Tenant: string;
};

const ModalUpdate = (props: any) => {
  const { currentUser } = useAuth();

  const [activeTab, setActiveTab] = useState<'UserDetails' | 'UserRoles'>('UserDetails');
  const [roles, setRoles] = useState<Role[]>([]);
  const [user, setUser] = useState<User>({
    firstName: '',
    lastName: '',
    email: '',
    NumberPhone: '',
    position: '',
    Roles: [],
    Tenant: '',
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.body.classList.add('modal-open');
    return () => {
      document.body.classList.remove('modal-open');
      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) backdrop.remove(); // Elimina cualquier backdrop residual
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (props.id && currentUser?.ListPermiso?.includes('User.UpdateProfile')) {
          const userResponse = await getmyuser();
          setUser(userResponse.data);

          if (currentUser?.ListPermiso?.includes('User.ChangeRoll')) {
            const rolesResponse = await getroles();
            if (rolesResponse.data && rolesResponse.data.length > 0) {
              setRoles(rolesResponse.data);
            } else {
              console.warn('No roles found.');
            }
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    if (props.id) {
      setLoading(true);
      fetchData();
    }
  }, [props.id, currentUser?.ListPermiso]);

  const handleSaveDetails = async () => {
    try {
      await axios.put(`${API_URL}/v1/auth0/users/update/`, user);
      Swal.fire('Success', 'User details updated successfully!', 'success');
      props.setID(null);
    } catch (error) {
      console.error(error);
      Swal.fire('Error', 'Failed to update user details.', 'error');
    }
  };

  const handleSaveRole = async () => {
    try {
      await axios.put(`${API_URL}/v1/auth0/users/update/`, user);
      Swal.fire('Success', 'User role updated successfully!', 'success');
      props.setID(null);
    } catch (error) {
      console.error(error);
      Swal.fire('Error', 'Failed to update user role.', 'error');
    }
  };

  const resetPassword = (email: string) => {
    Swal.fire({
      title: `Are you sure you want to reset the password for ${email}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, reset it!',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(`${API_URL}/v1/auth0/users/reset-password`, { email })
          .then(() => {
            Swal.fire('Success', 'Password reset email sent!', 'success');
          })
          .catch((err) => {
            Swal.fire('Error', 'Failed to send password reset email.', 'error');
            console.error(err);
          });
      }
    });
  };

  const handleCancel = () => {
    // Limpia el ID para cerrar el modal
    if (props.setID) {
      props.setID(null); // Reinicia el estado del ID
    }

    // Ejecuta el método onClose si está definido
    if (props.onClose) {
      props.onClose(); // Cierra el modal desde el componente padre
    }

    // Remueve clases residuales del modal
    document.body.classList.remove('modal-open');
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) backdrop.remove(); // Elimina cualquier fondo oscuro residual
  };

  if (!props.id) return null;

  return (
    <div>
      {/* Fondo opaco */}
      <div className="custom-modal-overlay"></div>

      {/* Modal */}
      <div className="modal fade show d-block">
        <div className="modal-dialog modal-dialog-centered mw-650px">
          <div className="modal-content">
            <ViewModalHeader setID={props.setID} />
            <div className="modal-body scroll-y mx-5 mx-xl-15">
              <div className="tab-header mb-4">
                <button
                  className={`tab-button ${activeTab === 'UserDetails' ? 'active' : ''}`}
                  onClick={() => setActiveTab('UserDetails')}
                >
                  User Details
                </button>
                <button
                  className={`tab-button ${activeTab === 'UserRoles' ? 'active' : ''}`}
                  onClick={() => setActiveTab('UserRoles')}
                >
                  User Role
                </button>
              </div>

              {loading ? (
                <div className="text-center">
                  <span className="spinner-border spinner-border-lg text-primary"></span>
                  <p>Loading user data...</p>
                </div>
              ) : activeTab === 'UserDetails' ? (
                <div>
                  {/* User Details Form */}
                  <div className="mb-3">
                    <label>Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={user.firstName}
                      onChange={(e) => setUser({ ...user, firstName: e.target.value })}
                    />
                  </div>
                  <div className="mb-3">
                    <label>Last Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={user.lastName}
                      onChange={(e) => setUser({ ...user, lastName: e.target.value })}
                    />
                  </div>
                  <div className="mb-3">
                    <label>Email</label>
                    <input
                      type="email"
                      className="form-control"
                      value={user.email}
                      onChange={(e) => setUser({ ...user, email: e.target.value })}
                    />
                  </div>
                  <div className="mb-3">
                    <label>Phone Number</label>
                    <input
                      type="text"
                      className="form-control"
                      value={user.NumberPhone}
                      onChange={(e) => setUser({ ...user, NumberPhone: e.target.value })}
                    />
                  </div>
                  <div className="mb-3">
                    <label>Job Title</label>
                    <input
                      type="text"
                      className="form-control"
                      value={user.position}
                      onChange={(e) => setUser({ ...user, position: e.target.value })}
                    />
                  </div>
                  <div className="d-flex justify-content-end align-items-center gap-2">
                    {/* Reset Password Button */}
                    <button
                      className="btn-light-marino f-parrafo"
                      onClick={() => resetPassword(user.email)}
                    >
                      Reset password
                    </button>

                    {/* Save Details Button */}
                    <button
                      className="btn-light-marino f-parrafo"
                      onClick={handleSaveDetails}
                    >
                      Save details
                    </button>
                  </div>

                  {/* Divider Line */}
                  <hr
                    style={{
                      border: 'none',
                      borderTop: '4px solid rgb(222, 226, 230)', // Borde más grueso
                      margin: '1rem 0',
                    }}
                  />

                  <div className="mt-3 text-end">
                    {/* Cancel Button */}
                    <button
                      className="btn-cancel btn border border-pink text-pink f-parrafo"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              ) : (
                <div>
                  {/* User Roles */}
                  {roles.length > 0 ? (
                    roles.map((role) => (
                      <div className="form-check" key={role.id}>
                        <input
                          type="radio"
                          className="form-check-input"
                          id={`role-${role.id}`}
                          checked={user.Roles.some((r) => r.id === role.id)}
                          onChange={() =>
                            setUser({
                              ...user,
                              Roles: [{ id: role.id, name: role.name }],
                            })
                          }
                        />
                        <label className="form-check-label" htmlFor={`role-${role.id}`}>
                          <div>{role.name}</div>
                          <small>{role.description}</small>
                        </label>
                      </div>
                    ))
                  ) : (
                    <p>No roles available.</p>
                  )}
                  <div className="d-flex justify-content-end align-items-center gap-2">
                    {/* Save Role Button */}
                    <button
                      className="btn-light-marino f-parrafo"
                      onClick={handleSaveRole}
                    >
                      Save roll
                    </button>
                  </div>

                  {/* Divider Line */}
                  <hr
                    style={{
                      border: 'none',
                      borderTop: '4px solid rgb(222, 226, 230)', // Borde fuerte
                      margin: '1rem 0',
                    }}
                  />

                  <div className="mt-3 text-end">
                    {/* Cancel Button */}
                    <button
                      className="btn-cancel btn border border-pink text-pink f-parrafo"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { ModalUpdate };
